<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">
            <!-- <div class="d-flex align-items-center">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a rouetLink="/mainview/dashboard" class="link">Dashboard</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page"> vendor Masters Management</li>
                    </ol>
                </nav>
            </div> -->
            <h4 class="page-title">Vendor Account Management</h4>
        </div>

    </div>
</div>
<!-- Container fluid  -->
<!-- ============================================================== -->
<div class="container-fluid" style="margin-top: 20px">
    <!-- ============================================================== -->
    <!-- Start Page Content -->
    <!-- ============================================================== -->
    <div class="row">
        <!-- Column -->
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">
                        <div id="zero_config_wrapper"
                            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                            <div class="row">
                                <div class="col-md-10">
                                    <label>Vendor Accounts Management</label>
                                </div>

                                <div class="col-md-1">
                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="filter()">
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                            Filter</button>
                                    </div>

                                </div>
                                <div class="col-md-1">

                                    <div id="zero_config_filter" class="dataTables_filter">
                                        <button style="background-color: #e0e09e" (click)="exportTable()">
                                            <i class="fa fa-download" aria-hidden="true"></i>
                                            Export</button>
                                    </div>

                                </div>
                            </div>
                            <div *ngIf="showFilter" style="background-color: #e0e09e;width: 895px;">
                                <div class="container-fluid" style="color: black">
                                    <input type="radio" id="emailId" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ei" (change)="applyCustomizedFilter()" style="margin-top: 29px;"> Account
                                    Email Id &nbsp;&nbsp;
                                    <input type="radio" id="name" name="gender" [(ngModel)]="filterValueSelected"
                                        value="mn" (change)="applyCustomizedFilter()"> Mobile Number &nbsp;&nbsp;
                                    <input type="radio" id="firstname" name="gender" [(ngModel)]="filterValueSelected"
                                        value="fn" (change)="applyCustomizedFilter()">First Name&nbsp;&nbsp;
                                    <input type="radio" id="lastName" name="gender" [(ngModel)]="filterValueSelected"
                                        value="ln" (change)="applyCustomizedFilter()">Last Name&nbsp;&nbsp;
                                    <input type="radio" id="aadhar" name="gender" [(ngModel)]="filterValueSelected"
                                        value="an" (change)="applyCustomizedFilter()">Aadhar Number&nbsp;&nbsp;
                                    <input type="radio" id="pan" name="gender" [(ngModel)]="filterValueSelected"
                                        value="pn" (change)="applyCustomizedFilter()">PAN Number&nbsp;&nbsp;
                                    <input type="radio" id="gstin " name="gender" [(ngModel)]="filterValueSelected"
                                        value="gst" (change)="applyCustomizedFilter()"> GSTIN &nbsp;&nbsp;



                                </div>
                                <div style="margin-left: 820px">

                                    <button class="btn btn-dark" (click)="filter()">Cancel</button>

                                </div>
                            </div>
                            <div>
                                <div>
                                    <mat-form-field *ngIf="showCustomisedSearch">

                                        <input class="search" placeholder="Search" matInput [(ngModel)]="searchValue"
                                            (keyup)="applyCustomizedFilterSearch(searchValue)">

                                    </mat-form-field>
                                    <mat-form-field *ngIf="!showCustomisedSearch">
                                        <input class="search" placeholder="Search" matInput
                                            (keyup)="applyFilter($event.target.value)">

                                    </mat-form-field>

                                </div>
                                <div class="table-responsive">
                                    <table class="table" id="Example table" mat-table [dataSource]="dataSource" matSort
                                        style=" margin-top: 30px;">

                                        <ng-container matColumnDef="_id">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Account Id</th>
                                            <td *matCellDef="let row">
                                                {{row._id}}
                                            </td>
                                        </ng-container>



                                        <ng-container matColumnDef="MobileNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                                            <td *matCellDef="let row">
                                                {{row.MobileNumber}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="MobileStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Status</th>
                                            <td *matCellDef="let row">
                                                {{row.MobileStatus}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="AccountEmailId">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Account Email Id</th>
                                            <td *matCellDef="let row">
                                                {{row.AccountEmailId}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="AccountStatus">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Email Status
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.AccountStatus}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="firstName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>First Name</th>
                                            <td *matCellDef="let row">
                                                {{row.firstName}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="lastName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name
                                            </th>
                                            <td *matCellDef="let row">
                                                {{row.lastName}}
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="dateOfBirth">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Of Birth</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfBirth|date}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="gender">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender </th>
                                            <td *matCellDef="let row">
                                                {{row.gender}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="GSTIn">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor GSTIN</th>
                                            <td *matCellDef="let row">
                                                {{row.GSTIn}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="aadharNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Aadhar Number</th>
                                            <td *matCellDef="let row">
                                                {{row.aadharNumber}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="panNumber">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Pan Number</th>
                                            <td *matCellDef="let row">
                                                {{row.panNumber}}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="kycVerification">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Approved by Admin</th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.kycVerification!='Pending'">
                                                    {{row.kycVerification}}</span>
                                                <select *ngIf="row.kycVerification=='Pending'" class="form-control"
                                                    name="verificationStatus" #verificationStatus
                                                    (change)="onChange(row._id,verificationStatus)">
                                                    <option value="Pending" disabled="" selected="">Pending</option>

                                                    <option value="Approved">Approve</option>
                                                    <option value="Rejected">Reject</option>

                                                </select>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="status">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vendor Status
                                            </th>
                                            <td *matCellDef="let row">
                                                <span *ngIf="row.status==true"> Active</span>
                                                <span *ngIf="row.status==false"> In Active</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="dateOfCreation">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date of Creation</th>
                                            <td *matCellDef="let row">
                                                {{row.dateOfCreation|date}}
                                            </td>
                                        </ng-container>


                                        <ng-container matColumnDef="Actions">
                                            <th mat-header-cell *matHeaderCellDef>Actions</th>

                                            <td *matCellDef="let row">
                                                <!-- <p *ngIf="read==true  && delete!=true && write !=true "
                                                    style="color:#353556;font-family: initial;font-weight: 500;">You
                                                    didn't have permission for actions</p> -->

                                                <ul class="list-group list-group-flush">
                                                    <li class="list-group-item  friend-list mb-2">

                                                        <div class="dropdown show float-right list-block">

                                                            <a class="userDropdown" href="#" role="button"
                                                                id="userDropdown" data-toggle="dropdown"
                                                                aria-haspopup="true" aria-expanded="false"
                                                                style="padding-right: 170px;"></a>
                                                            <div class="dropdown-menu dropdown-menu-right"
                                                                aria-labelledby="userDropdown">

                                                                <button class="dropdown-item"
                                                                    (click)="deleteVendorAccount(row._id)">
                                                                    <i class="fa fa-trash p-2"
                                                                        aria-hidden="true"></i>Delete</button>
                                                                <div>
                                                                    <mat-slide-toggle
                                                                        (change)="onStatusChange($event,row._id)"
                                                                        [checked]="row.status">
                                                                        <span *ngIf="row.status==false">
                                                                            In Active</span>
                                                                        <span *ngIf="row.status==true">
                                                                            Active</span>
                                                                    </mat-slide-toggle>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </li>
                                                </ul>
                                            </td>
                                        </ng-container>


                                        <tr mat-header-row *matHeaderRowDef='displayedColumns'>
                                        </tr>
                                        <tr mat-row *matRowDef="let row;columns:displayedColumns"></tr>
                                    </table>
                                </div>

                            </div>
                        </div>
                    </div>
                    <mat-paginator style="margin-right:200px" [length]="100" [pageSize]="10"
                        [pageSizeOptions]="[5, 10, 25,100]" showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
        <!-- Column -->
    </div>
    <!-- ============================================================== -->
    <!-- End PAge Content -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Right sidebar -->
    <!-- ============================================================== -->
    <!-- .right-sidebar -->
    <!-- ============================================================== -->
    <!-- End Right sidebar -->
    <!-- ============================================================== -->
</div>